import readingTime from 'reading-time';
import { FIRST_IMAGE_FEATURE } from '../../DaEditorWrapper/Features/firstImage';
import { getFeature } from '../../DaEditorWrapper/Features';
import { WORD_COUNT_FEATURE } from '../../DaEditorWrapper/Features/wordCount';
import get from 'lodash/get';
import MediaService from '../../utils/DeviationMediaService';
export var getCoverImageAttributes = function (source) {
    if (!source.deviation) {
        return;
    }
    var preview = getCoverImageFile(source);
    if (!preview) {
        return;
    }
    var style = {
        backgroundImage: "url('" + preview.src + "')",
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'top',
        backgroundSize: 'cover',
    };
    return { style: style };
};
export function getCoverImageFile(source) {
    if (source.deviation && source.deviation.coverImage) {
        return getCoverImageWithDraftJSType(source);
    }
    return get(source.deviation, 'textContent.html.type') === 'writer'
        ? getCoverImageWithWriterType(source)
        : getCoverImageWithDraftJSType(source);
}
/**
 * DraftJS has two versions:
 * - Legacy first image was used in beta stages
 * - CoverImage was when we let users select the cover
 */
function getCoverImageWithDraftJSType(source) {
    if (!source.deviation) {
        return;
    }
    // See if we have first image feature, newer journals wont have anything
    var firstImageFeature = getFeature(FIRST_IMAGE_FEATURE, get(source.deviation, 'textContent.html.features', []));
    var firstImage = get(firstImageFeature, 'data.deviation');
    // cover image can either be inside the coverImage property or
    // if its not a text deviation its the passed deviation itself.
    var _a = source.deviation, sourceTextContent = _a.textContent, sourceCoverImage = _a.coverImage;
    var coverImage = sourceCoverImage || (!sourceTextContent && source.deviation);
    if (!firstImage && !coverImage) {
        return undefined;
    }
    if (coverImage.isBlocked) {
        return;
    }
    // We have a cover to use
    // Default width/height for when its not passed
    // Prefer coverImage over firstImage
    // Get the thumbset to search on and filter out default images
    var _b = source.width, width = _b === void 0 ? 300 : _b, _c = source.height, height = _c === void 0 ? 300 : _c, allowHuge = source.allowHuge;
    var deviation = coverImage || firstImage;
    // Finally we try and find a image that will cover the requested block size
    return MediaService.getSmallestThumbThatFullyCovers(deviation, width, height, function (t) { return t[t.length - 1]; }, // Take largest if nothing covers
    {
        allowPreview: allowHuge,
        allowFullview: allowHuge,
    });
}
/**
 * Legacy journals get cover only if they have social preview
 */
function getCoverImageWithWriterType(source) {
    if (source.deviation && source.deviation.isBlocked) {
        return;
    }
    return MediaService.getDeviationFile(source.deviation, 'social_preview');
}
export var getReadingTimeMinutes = function (textContent) {
    if (!textContent || !textContent.html.markup) {
        return 0;
    }
    if (!isTextContentDraftJs(textContent)) {
        // Wrong but meh...
        return Math.ceil(readingTime(textContent.html.markup).minutes);
    }
    var counts = getFeature(WORD_COUNT_FEATURE, textContent.html.features);
    if (!counts) {
        return 0;
    }
    return Math.ceil(counts.data.words / 200);
};
export var isTextContentDraftJs = function (textContent) {
    return !!(textContent && textContent.html && textContent.html.type === 'draft');
};
//# sourceMappingURL=helpers.js.map